import { render, staticRenderFns } from "./SelectContianer.vue?vue&type=template&id=523965ba&scoped=true&"
import script from "./SelectContianer.vue?vue&type=script&lang=js&"
export * from "./SelectContianer.vue?vue&type=script&lang=js&"
import style0 from "./SelectContianer.vue?vue&type=style&index=0&id=523965ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523965ba",
  null
  
)

export default component.exports